let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("auBTD")).then(() => parcelRequire('5D8Rs'));